import { makeAutoObservable } from 'mobx';
import { IAction, IIntegartionSettings, INTEGRATION_ACTION } from '../../../../models/IntegrationsTypes';
import { IChangeable } from '../../../../stores/types';

interface IIntegartionSettingsChanges extends Partial<IIntegartionSettings> {};

class IntegrationSettingStore implements IChangeable<IIntegartionSettings> {
    private _model: IIntegartionSettings = {} as IIntegartionSettings;
    private _changes: IIntegartionSettingsChanges = {};

    public get id() { return this._model?.id; }
    public get label() { return this._preset.label; }
    public get type() { return this._preset.type; }
    public get default() { return this._preset.default; }
    public get currentValue() { return this._changes.status ?? this._model.status; }
    public get dropDownValues() { return this._preset.values; }
    public get dropDownValueName() { return this.dropDownValues?.find(option => option.id === this.currentValue)?.label || ''; }
    public get isHidden() { return this._preset?.is_hidden ?? false; }
    public get note() { return this.dropDownValues?.find(option => option.id === this.currentValue)?.note; }
    public get isOptional() { return this._preset.optional ?? false; }
    public get description() { return this._preset.description; }

    constructor(private _preset: IAction, model?: IIntegartionSettings) {
        if (model) {
            this._model = model;
        }

        makeAutoObservable(this);
    }

    public setCurrentValue(v: boolean | string) {
        this._changes.status = v;
        this._clearUnneededChanges();
    }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public getUpdatedModel(): IIntegartionSettings|undefined {
        const hasThisModelChanges = !!Object.keys(this._changes).length;

        /** if the object is new and does not have changes - no need to send it to server */
        if (!this._model.id && !this.hasChanges()) {
            return undefined;
        }

        return { ...this._model, ...this._changes, action: this._preset.id as INTEGRATION_ACTION, _has_changes: hasThisModelChanges };
    }

    private _clearUnneededChanges() {
        Object.keys(this._changes).forEach(key => {
            const theKey = key as keyof IIntegartionSettings;
            if (this._changes[theKey] === this._model?.[theKey]) {
                delete this._changes[theKey];
            }
        });
    }
}

export default IntegrationSettingStore;
